import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    // Store the attempted URL and project ID for redirect after login
    const projectId = route.params['project_id'];
    const returnUrl = state.url;
    
    // Navigate to login with preserved state
    this.router.navigate(['/flow-status'], {
      state: {
        type: 'unauthorized',
        returnUrl: returnUrl,
        projectId: projectId
      }
    });
    
    return false;
  }
}
